// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IEntityAttributeDto
 */
export interface IEntityAttributeDto {
    /**
     * 
     * @type {string}
     * @memberof IEntityAttributeDto
     */
    attribute_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IEntityAttributeDto
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof IEntityAttributeDto
     */
    label?: string;
}

/**
 * Check if a given object implements the IEntityAttributeDto interface.
 */
export function instanceOfIEntityAttributeDto(value: object): value is IEntityAttributeDto {
    return true;
}

export function IEntityAttributeDtoFromJSON(json: any): IEntityAttributeDto {
    return IEntityAttributeDtoFromJSONTyped(json, false);
}

export function IEntityAttributeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEntityAttributeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'attribute_name': json['attribute_name'] == null ? undefined : json['attribute_name'],
        'type': json['type'] == null ? undefined : json['type'],
        'label': json['label'] == null ? undefined : json['label'],
    };
}

export function IEntityAttributeDtoToJSON(json: any): IEntityAttributeDto {
    return IEntityAttributeDtoToJSONTyped(json, false);
}

export function IEntityAttributeDtoToJSONTyped(value?: IEntityAttributeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'attribute_name': value['attribute_name'],
        'type': value['type'],
        'label': value['label'],
    };
}

